import { App } from 'vue'
import AliIcon from '@/components/Icon/AliIcon.vue';
import Editor from '@/components/Editor/index.vue';
import DictTag from '@/components/DictTag/index.vue';
import { SingleFileUpload, ButtonUpload, MultiFileUpload, UploadProgress } from '@/components/Upload';

/**
 * 注册全局组件
 * @param app - Vue应用实例
 */
export const registerGlobalComponents = (app : App) : void => {
  // 注册阿里图标组件
  app.component('AliIcon', AliIcon)

  app.component('Editor', Editor)
  app.component('DictTag', DictTag)
  
  // 注册上传组件
  app.component('SingleFileUpload', SingleFileUpload)
  app.component('ButtonUpload', ButtonUpload)
  app.component('MultiFileUpload', MultiFileUpload)
  
  // 注册文件上传进度组件
  app.component('UploadProgress', UploadProgress)
}